import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

export default {
  computed: {
    universe () {
      return this.$store.getters.getSitimmoUser.univers
    }
  },
  methods: {
    /**
     * Vérifie si un post est actuellement publié sur les réseaux sociaux
     * @param {number} postId - L'ID du post à vérifier
     * @param {string} postType - Le type de post ('annonce', 'bien_vendu' ou 'editorial')
     * @returns {Promise<{hasRSPublished: boolean, allRSPublished: boolean}>}
     */
    async checkPostPublicationStatus (postId, postType) {
      try {
        // Construire les portalCodes spécifiques au type de post
        let portalCodes = []
        
        if (postType === 'bien_vendu') {
          portalCodes = [
            `FACEBOOK_POST_${this.universe}_BIENS_VENDUS`,
            `INSTAGRAM_${this.universe}_BIENS_VENDUS`,
            `GOOGLE_MY_BUSINESS_${this.universe}_BIENS_VENDUS`,
            `LINKEDIN_${this.universe}_BIENS_VENDUS`
          ]
        } else if (postType === 'editorial') {
          portalCodes = [
            'FACEBOOK_EDITO',
            'INSTAGRAM_EDITO',
            'GOOGLE_MY_BUSINESS_EDITO',
            'LINKEDIN_EDITO'
          ]
        } else {
          // Pour les annonces normales
          portalCodes = [
            `FACEBOOK_POST_${this.universe}`,
            `INSTAGRAM_${this.universe}`,
            `GOOGLE_MY_BUSINESS_${this.universe}`,
            `LINKEDIN_${this.universe}`
          ]
        }

        // Construction des paramètres de requête
        const params = new URLSearchParams()
        portalCodes.forEach(code => {
          params.append('portalCodes[]', code)
        })

        const response = await HTTP_HYPER_ESPACE_BACKEND.get(
          `/diffusion-annonce/${postId}/isCurrentlyPublished?${params.toString()}`
        )

        if (response.status === 200 && response.data) {
          // L'API devrait retourner uniquement les portails qu'on lui a demandés
          return {
            hasRSPublished: response.data.hasRSPublished || false,
            allRSPublished: response.data.allRSPublished || false
          }
        }

        return {
          hasRSPublished: false,
          allRSPublished: false
        }
      } catch (error) {
        console.error('Erreur lors de la vérification du statut de publication:', error)
        return {
          hasRSPublished: false,
          allRSPublished: false
        }
      }
    }
  }
}
